import { createContext, useMemo, type ReactNode } from 'react';
import { useScrollDirection } from '@/hooks/useScrollDirection';

interface HeaderContextValue {
  /** ヘッダーが表示されているか */
  isHeaderVisible: boolean;
  /** ヘッダーの高さ（px） */
  headerHeight: number;
  /** スティッキー要素のtop値 */
  stickyTop: number;
  /** ページ最上部付近にいるか */
  isAtTop: boolean;
}

// eslint-disable-next-line react-refresh/only-export-components
export const HeaderContext = createContext<HeaderContextValue | null>(null);

const HEADER_HEIGHT = 64; // h-16 = 64px
const STICKY_GAP_VISIBLE = 8; // ヘッダー表示時のギャップ
const STICKY_GAP_HIDDEN = 8; // ヘッダー非表示時のギャップ

export function HeaderProvider({ children }: { children: ReactNode }) {
  const { shouldShowHeader, isAtTop } = useScrollDirection({ threshold: 10 });

  const stickyTop = shouldShowHeader
    ? HEADER_HEIGHT + STICKY_GAP_VISIBLE
    : STICKY_GAP_HIDDEN;

  const value = useMemo(
    () => ({
      isHeaderVisible: shouldShowHeader,
      headerHeight: HEADER_HEIGHT,
      stickyTop,
      isAtTop,
    }),
    [shouldShowHeader, stickyTop, isAtTop]
  );

  return (
    <HeaderContext.Provider value={value}>
      {children}
    </HeaderContext.Provider>
  );
}

